import React from "react";

interface ToggleSettingProps {
  label: string;
  description: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  showBackground?: boolean;
}

const ToggleSetting: React.FC<ToggleSettingProps> = ({
  label,
  description,
  checked,
  onChange,
  showBackground = false,
}) => {
  return (
    <div
      className={`p-2 lg:p-3 rounded-lg flex items-center justify-between gap-4 ${showBackground ? "bg-gray-50" : ""
        }`}
    >
      <div className="flex-1 min-w-0">
        <label className="block text-xs lg:text-sm font-medium text-gray-900 truncate">
          {label}
        </label>
        <p className="text-[10px] lg:text-xs text-gray-500 mt-0.5 leading-relaxed">
          {description}
        </p>
      </div>
      <label className="relative inline-flex items-center cursor-pointer shrink-0">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          className="sr-only peer"
        />
        <div className="w-9 h-5 lg:w-11 lg:h-6 bg-gray-300 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-purple-500/40 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 lg:after:h-5 lg:after:w-5 after:transition-all peer-checked:bg-[#885ABB]"></div>
      </label>
    </div>
  );
};

export default ToggleSetting;
